<template>
  <!-- 快捷操作 -->
  <div class="shortcut_operation">
    <ul>
      <li class="back_to_top">
        <a href="javascript:void(0)" class="service" :class="{ to_left: isBackLeft }" @mousemove="backToMove" @mouseleave="backToLeave" @click="back">
          <div class="img_box">
            <img src="@/assets/images/back.png">
          </div>
          <p>返回上页</p>
        </a>
      </li>
      <li class="back_to_top wxkf">
        <a class="service" :class="{ to_left: is_serviceLeft0 }" @mousemove="serviceMove0" @mouseleave="serviceLeave0">
          <div class="img_box">
            <img border="0" src="@/assets/images/weibo.png" />
          </div>
          <p>新浪微博</p>
        </a>
        <div class="kf0" v-show="is_showkf0"><img border="0" src="@/assets/images/weibo1.jpg" /></div>
      </li>
      <li class="back_to_top wxkf">
        <a class="service" :class="{ to_left: is_serviceLeft1 }" @mousemove="serviceMove1" @mouseleave="serviceLeave1">
          <div class="img_box">
            <img border="0" src="@/assets/images/weixin.png" />
          </div>
          <p>客服微信</p>
        </a>
        <div class="kf1" v-show="is_showkf1"><img border="0" src="@/assets/images/kf1.png" /></div>
      </li>
      <li class="back_to_top">
        <a class="service" :class="{ to_left: is_serviceLeft2 }" @mousemove="serviceMove2" @mouseleave="serviceLeave2">
          <div class="img_box">
            <img border="0" src="@/assets/images/kefu_icon.png" />
          </div>
          <p style="padding:0 7.5px;font-size:12px;">400-9005-905</p>
        </a>
      </li>
      <li class="back_to_top">
        <a class="service" :class="{ to_left: is_phoneLeft }" @mousemove="phoneMove" @mouseleave="phoneLeave" @click="backToTop">
          <div class="img_box">
            <img src="@/assets/images/dianhua.png">
          </div>
          <p style="padding:0 7.5px;font-size:12px;">043180872580</p>
        </a>
      </li>
      <!-- <li class="back_to_top">
				<a target="_blank" class="service" :class="{ to_left: is_serviceLeft }" @mousemove="serviceMove" @mouseleave="serviceLeave" href="http://wpa.qq.com/msgrd?v=3&uin=705829020&site=qq&menu=yes">
					<div class="img_box">
						<img border="0" src="@/assets/images/kefu_icon.png?p=2:705829020:53" alt="点击这里给我发消息" title="点击这里给我发消息"/>
					</div>
					<p>联系客服</p>
				</a>
			</li> -->
      <!-- 点击这里在线答疑 -->
      <li class="back_to_top">
        <a class="service" :class="{ to_left: is_serviceLeft3 }" @mousemove="serviceMove3" @mouseleave="serviceLeave3" href="https://work.weixin.qq.com/kfid/kfc52f9170d92700377">
          <div class="img_box">
            <img border="0" src="@/assets/images/kefu_icon.png" alt="在线答疑" />
          </div>
          <p style="padding:0 10.5px;font-size:12px;">点我在线答疑</p>
        </a>
      </li>

      <li class="back_to_top">
        <a href="javascript:void(0)" :class="{ to_left: isLeft }" @mousemove="backToTopMove" @mouseleave="backToTopLeave" @click="backToTop">
          <div class="img_box">
            <img src="@/assets/images/back_to_top.png">
          </div>
          <p>返回顶部</p>
        </a>
      </li>

    </ul>
  </div>
</template>

<script>
export default {
  name: 'ShortcutOperation',
  data () {
    return {
      isLeft: false,
      isBackLeft: false,
      is_serviceLeft0: false,
      is_serviceLeft1: false,
      is_serviceLeft2: false,
      is_serviceLeft3: false,
      is_showkf0: false,
      is_showkf1: false,
      is_showkf2: false,
      is_phoneLeft: false,
    }
  },
  created () {

  },
  watch: {

  },
  mounted () {

  },
  computed: {

  },
  methods: {
    backToMove: function () {
      this.isBackLeft = true
    },
    backToLeave: function () {
      this.isBackLeft = false
    },
    back: function () {
      this.$router.go(-1);
    },
    serviceMove0: function () {
      this.is_serviceLeft0 = true
      this.is_showkf0 = true
    },
    serviceLeave0: function () {
      this.is_serviceLeft0 = false
      this.is_showkf0 = false
    },
    serviceMove1: function () {
      this.is_serviceLeft1 = true
      this.is_showkf1 = true
    },
    serviceLeave1: function () {
      this.is_serviceLeft1 = false
      this.is_showkf1 = false
    },
    serviceMove2: function () {
      this.is_serviceLeft2 = true
      // this.is_showkf2 = true
    },
    serviceMove3: function () {
      this.is_serviceLeft3 = true
      // this.is_showkf2 = true
    },
    serviceLeave2: function () {
      this.is_serviceLeft2 = false
      // this.is_showkf2 = false
    },
    serviceLeave3: function () {
      this.is_serviceLeft3 = false
      // this.is_showkf2 = false
    },
    phoneMove: function () {
      this.is_phoneLeft = true
    },
    phoneLeave: function () {
      this.is_phoneLeft = false
    },
    backToTopMove: function () {
      this.isLeft = true
    },
    backToTopLeave: function () {
      this.isLeft = false
    },
    backToTop: function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }
}
</script>
<style scoped>
.wxkf {
  /* position: relative; */
  text-align: right;
}
.wxkf .kf1,
.wxkf .kf2,
.wxkf .kf0 {
  /* position: absolute; */

  margin-top: -20px;
  margin-bottom: 20px;
  margin-left: 20px;
}
.wxkf .kf1 img,
.wxkf .kf2 img,
.wxkf .kf0 img {
  width: 100px;
}
</style>